module.exports = __webpack_public_path__ + "media/images/redesign-images/get-inspired/gi-blog-4-93d483d62fba9c165c371d6e59d5d071.jpg";